// Navigation — overlay open/close, tab switching, panel toggles

(function () {
  const navOverlay  = document.getElementById('nav-overlay');
  const navOpen     = document.getElementById('nav-open') || document.getElementById('nav-toggle');
  const navClose    = document.getElementById('nav-close');

  // ── OVERLAY OPEN / CLOSE ─────────────────────────────────────
  function openNav() {
    if (!navOverlay) return;
    navOverlay.classList.add('open');
    navOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    if (!navOverlay) return;
    navOverlay.classList.remove('open');
    navOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (navOpen)  navOpen.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);

  // Backdrop click to close
  if (navOverlay) {
    navOverlay.addEventListener('click', e => {
      if (e.target === navOverlay) closeNav();
    });
  }

  // ── TAB SWITCHING ────────────────────────────────────────────
  const tabs   = document.querySelectorAll('.nav-tab');
  const panels = document.querySelectorAll('.nav-panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove('nav-tab--active'));
      tab.classList.add('nav-tab--active');

      panels.forEach(p => {
        if (p.id === `nav-panel-${target}`) {
          p.classList.remove('nav-panel--hidden');
        } else {
          p.classList.add('nav-panel--hidden');
        }
      });
    });
  });

  // ── COLOR WALL PANEL TOGGLES ─────────────────────────────────
  const refineBtn   = document.getElementById('cw-refine-btn');
  const refinePanel = document.getElementById('cw-refine-panel');
  const sortBtn     = document.getElementById('cw-sort-btn');
  const sortPanel   = document.getElementById('cw-sort-panel');

  if (refineBtn && refinePanel) {
    refineBtn.addEventListener('click', () => {
      refinePanel.hidden = !refinePanel.hidden;
      if (sortPanel) sortPanel.hidden = true;
    });
  }

  if (sortBtn && sortPanel) {
    sortBtn.addEventListener('click', () => {
      sortPanel.hidden = !sortPanel.hidden;
      if (refinePanel) refinePanel.hidden = true;
    });
  }

  // ── SCROLL — transparent → white header ─────────────────────
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    window.addEventListener('scroll', () => {
      siteHeader.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── ESCAPE KEY ───────────────────────────────────────────────
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeNav();
    if (refinePanel) refinePanel.hidden = true;
    if (sortPanel)   sortPanel.hidden   = true;
    const cartDrawer  = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    if (cartDrawer)  cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  });

  // ── CART COUNT BADGE ─────────────────────────────────────────
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('#cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (_) {}
  }
  updateCartCount();

})();
